import { persist } from 'zustand/middleware';

import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const initialState = {
  searchValue: '',
  userStatusValue: 'all',
  tableSortingValue: initialSorting,
};

const useUsersStore = createStore(
  persist(
    (set) => ({
      ...initialState,

      actions: {
        setUsersSearchValue: (searchValue) => set({ searchValue }),
        setUsersStatusValue: (userStatusValue) => set({ userStatusValue }),
        setUsersTableSortingValue: (tableSortingValue) => set({ tableSortingValue }),
        setUsersResetValues: () => set({ ...initialState }),
      },
    }),
    {
      version: 3,
      name: 'user-filters',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) => key !== 'actions' && key !== 'searchValue' && key !== 'tableSortingValue',
          ),
        ),
    },
  ),
  'UsersStore',
);

export const useUsersActions = () => useUsersStore((state) => state.actions);

export const selectUsersSearchValue = () => useUsersStore((state) => state.searchValue);
export const selectUsersStatusValue = () => useUsersStore((state) => state.userStatusValue);
export const selectUsersTableSortingValue = () => useUsersStore((state) => state.tableSortingValue);
